import {
  COOKIE_CONSENTIMENTO_NOME,
  isConsentimentoConcedido,
  resolverConsentimento,
} from '@shared/cookie-consent/utils/cookieConsentRules';
import cookieService from '@/services/CookieService';
import storageService from '@/services/StorageService';

/**
 * Importa os serviços pelos arquivos, e não pelo barrel `@/services`: este helper é usado
 * dentro de serviços que o barrel exporta, e o barrel geraria import circular.
 */
export function possuiConsentimentoAtivo(): boolean {
  const armazenado = storageService.meuacerto.get() ?? {};
  const cookie = cookieService.getCookie(COOKIE_CONSENTIMENTO_NOME);

  return isConsentimentoConcedido(resolverConsentimento(cookie, armazenado));
}
